import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./SlickCarousel.module.css";

const SlickCarousel = ({ images, variant }) => {
	const [enableAutoplay, setEnableAutoplay] = useState(false);
	const isMobile = window.innerWidth < 768;
	const baseImageUrl = 'https://images.sweetorsalted.com/';

	useEffect(() => {
		const t = setTimeout(() => {
		setEnableAutoplay(true);
		}, 300);

		return () => clearTimeout(t);
	}, []);

	// ✅ SAFE early return (after hooks)
	if (!Array.isArray(images) || images.length === 0) {
		return null;
	}

	return (
		<Slider
			dots
			fade={!isMobile}
			autoplay={enableAutoplay && !isMobile}
			autoplaySpeed={4000}
			infinite
			speed={600}
			slidesToShow={1}
			slidesToScroll={1}
			swipe
			touchMove
			draggable
			>
			{images.map((src, i) => (
				<div key={i}>
					<div
						className={`${classes.CarouselImageWrapper} ${classes[variant]}`}
						style={{ backgroundImage: `url("${baseImageUrl + src}")` }}
					>
						<img
						src={baseImageUrl + src}
						alt={`Recipe ${i + 1}`}
						/>
					</div>
				</div>
			))}
		</Slider>
	);
};

export default SlickCarousel;

//WORKING VERSION OF DISPLAING 3 IMAGES AS ONE
// import React, { useEffect, useState, useMemo } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import classes from "./SlickCarousel.module.css";

// const SlickCarousel = ({ images = [], variant, isLandingPage }) => {
//   const [enableAutoplay, setEnableAutoplay] = useState(false);
//   const isMobile = window.innerWidth < 768;
//   const baseImageUrl = "https://images.sweetorsalted.com/";

//   useEffect(() => {
//     const t = setTimeout(() => {
//       setEnableAutoplay(true);
//     }, 300);
//     return () => clearTimeout(t);
//   }, []);

//   // ✅ ALWAYS run hooks before any return
//   const groupedImages = useMemo(() => {
//     if (!isLandingPage) return images;

//     const groups = [];
//     for (let i = 0; i < images.length; i += 3) {
//       groups.push(images.slice(i, i + 3));
//     }
//     return groups;
//   }, [images, isLandingPage]);

//   // ✅ Safe early return AFTER hooks
//   if (!Array.isArray(images) || images.length === 0) {
//     return null;
//   }

//   const settings = {
//     dots: true,
//     fade: !isMobile && !isLandingPage,
//     autoplay: enableAutoplay && !isMobile,
//     autoplaySpeed: 4000,
//     infinite: true,
//     speed: 600,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     swipe: true,
//     touchMove: true,
//     draggable: true
//   };

//   return (
//     <Slider {...settings}>
//       {isLandingPage
//         ? groupedImages.map((group, index) => (
//             <div key={index}>
//               <div
//                 className={`${classes.MultiImageSlide} ${classes[variant]}`}
//               >
//                 {group.map((src, i) => (
//                   <div key={i} className={classes.SmallImageWrapper}>
//                     <img
//                       src={baseImageUrl + src}
//                       alt={`Recipe ${index * 3 + i + 1}`}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))
//         : images.map((src, i) => (
//             <div key={i}>
//               <div
//                 className={`${classes.CarouselImageWrapper} ${classes[variant]}`}
//                 style={{
//                   backgroundImage: `url("${baseImageUrl + src}")`
//                 }}
//               >
//                 <img
//                   src={baseImageUrl + src}
//                   alt={`Recipe ${i + 1}`}
//                 />
//               </div>
//             </div>
//           ))}
//     </Slider>
//   );
// };

// export default SlickCarousel;

